// Shared audit-action display labels so every surface that renders audit logs
// (Admin Panel User Management, Settings Sub Account Audit tab, etc.) stays
// consistent. Keep in sync with backend `AuditAction` enum values.
export const AUDIT_ACTION_LABELS = {
  user_created: 'Account Created',
  user_updated: 'Profile Updated',
  user_deleted: 'Account Deleted',
  user_login: 'Login',
  user_login_failed: 'Failed Login',
  trusted_device_removed: 'Trusted Device Removed',
  trusted_network_removed: 'Trusted Network Removed',
  sessions_purged: 'Stale Sessions Purged',
  user_logout: 'Logout',
  user_blocked: 'Account Blocked',
  user_unblocked: 'Account Unblocked',
  password_changed: 'Password Changed',
  role_changed: 'Role Changed',
  expiry_changed: 'Account Expiry Changed',
  features_updated: 'Features Updated',
  devices_assigned: 'Devices Assigned',
  resource_limits_changed: 'Resource Limits Changed',
  user_impersonated: 'Account Accessed (Impersonation)',
  impersonation_ended: 'Impersonation Ended',
  device_created: 'Device Created',
  device_updated: 'Device Action',
  device_deleted: 'Device Deleted',
  device_allocated: 'Device Allocation Changed',
  command_sent: 'Command Sent',
  device_deactivation_wizard: 'Device Deactivation Wizard',
  device_reactivation_wizard: 'Device Reactivation Wizard',
  user_deactivation_wizard: 'User Deactivation Wizard',
  user_reactivation_wizard: 'User Reactivation Wizard',
  banner_sent: 'Banner Sent',
  banner_cancelled: 'Banner Cancelled',
  banner_link_clicked: 'Banner Link Clicked',
  session_expired: 'Session Expired',
  session_ended_inactive: 'Session Ended (Inactive)',
  session_resumed: 'Session Resumed',
  geofence_created: 'Geofence Created',
  geofence_updated: 'Geofence Updated',
  geofence_deleted: 'Geofence Deleted',
  global_settings_changed: 'Global Settings Changed',
};

export function getAuditActionLabel(action) {
  return (
    AUDIT_ACTION_LABELS[action] ||
    action?.replace(/_/g, ' ').replace(/\b\w/g, (l) => l.toUpperCase()) ||
    action
  );
}
